import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAdjustmentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={20}
    fill="none"
    viewBox="0 0 18 20"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.285 6.596c.782 0 1.416-.709 1.416-1.583s-.634-1.583-1.416-1.583c-.783 0-1.417.709-1.417 1.583s.634 1.583 1.417 1.583M3.2 5.016h5.667M11.7 5.016h2.834M6.033 11.346c.782 0 1.417-.709 1.417-1.583S6.815 8.18 6.033 8.18c-.783 0-1.417.709-1.417 1.583s.634 1.583 1.417 1.583M3.2 9.766h1.417M7.451 9.766h7.084M12.409 16.096c.782 0 1.416-.709 1.416-1.583s-.634-1.583-1.416-1.583c-.783 0-1.417.709-1.417 1.583s.634 1.583 1.417 1.583M3.2 14.516h7.792M13.825 14.516h.709"
    />
  </svg>
);
export default SvgAdjustmentIcon;
